import { gsap } from 'gsap'
import { module } from 'modujs'
import { debounce } from '../utils/tickers'

export default class extends module {
  init() {
    const els = [...this.el.querySelectorAll('[data-collapse]')]

    this.collapses = els.map((el) => {
      const collapse = {
        el,
        toggle: el.querySelector('[data-collapse-toggle]'),
        content: el.querySelector('[data-collapse-content]'),
        callback: () => {
          this.onClickCollapseToggle(el)
        }
      }

      collapse.toggle?.addEventListener('click', collapse.callback)

      return collapse
    })

    this.resizeCallback = debounce(
      () => {
        this.resizeCollapsesContents()
      },
      10,
      false
    )

    window.addEventListener('resize', this.resizeCallback)
  }

  onClickCollapseToggle(el) {
    const collapse = this.collapses.find(collapse => collapse.el === el)
    const contentHeight = el.querySelector('[data-collapse-content-inner]').offsetHeight

    el.toggleAttribute('data-collapse-opened')

    gsap.to(collapse.content, {
      height: el.hasAttribute('data-collapse-opened')
        ? contentHeight
        : 0,
      ease: 'expo.out',
      duration: 0.8,
      onComplete: () => {
        this.call('resize', 'Scroll')
      }
    })
  }

  resizeCollapsesContents() {
    if (this.el.querySelectorAll('[data-collapse-opened]')) {
      this.el.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
        const contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight

        collapse.querySelector('[data-collapse-content]').style.height = `${contentHeight}px`
      })
    }
  }

  destroy() {
    window.removeEventListener('resize', this.resizeCallback)
    this.collapses.forEach((collapse) => {
      collapse.toggle?.removeEventListener('click', collapse.callback)
    })
  }
}
